"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var _themeUi = require("theme-ui");

var React = _interopRequireWildcard(require("react"));

var _Box = _interopRequireDefault(require("../../../../Layout/Box"));

var _Text = _interopRequireDefault(require("../../../Text"));

var _Hidden = require("../../../../Modules/Hidden");

var _Toggle = require("./Toggle");

var _Input = require("./Input");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

/** @jsx jsx */
var Password = React.forwardRef(function (_a, ref) {
  var hideText = _a.hideText,
      showText = _a.showText,
      props = (0, _tslib.__rest)(_a, ["hideText", "showText"]);

  var _b = React.useState(false),
      showPassword = _b[0],
      setShowPassword = _b[1];

  var type = showPassword ? 'text' : 'password';
  return (0, _themeUi.jsx)(_Box.default, {
    sx: {
      position: 'relative'
    }
  }, (0, _themeUi.jsx)(_Input.PasswordInput, (0, _tslib.__assign)({}, props, {
    ref: ref,
    type: type
  })), (0, _themeUi.jsx)(_Toggle.PasswordToggle, {
    "aria-labelledby": "eye-description",
    onClick: function onClick() {
      return setShowPassword(!showPassword);
    },
    type: "button",
    variant: "passwordToggle"
  }, showPassword ? (0, _themeUi.jsx)(_Toggle.PasswordToggle.Hidden, {
    "aria-describedby": "password hidden"
  }) : (0, _themeUi.jsx)(_Toggle.PasswordToggle.Visible, {
    "aria-describedby": "password visible"
  }), (0, _themeUi.jsx)(_Text.default, {
    id: "eye-description",
    css: _Hidden.hiddenCss
  }, showPassword ? hideText : showText)));
});
Password.displayName = 'Password';
Password.defaultProps = {
  hideText: 'Hide password',
  showText: 'Show password'
};
var _default = Password;
exports.default = _default;